import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { PerformanceSection } from './components/PerformanceSection';
import { TeamSection } from './components/TeamSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { SEO } from './components/SEO';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <SEO data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <AboutSection data-id="element-5" />
        <ServicesSection data-id="element-6" />
        <PerformanceSection data-id="element-7" />
        <TeamSection data-id="element-8" />
        <ContactSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}